<fieldset class="group" [formGroup]="group()">
    <legend>{{ "FLIGHT_LIST.groups.flight" | translate }}</legend>
    <div class="fields single">
        <label class="field">
            <span class="label">{{ "FLIGHT_LIST.flightType" | translate }}</span>
            <kendo-combobox
                formControlName="flightTypeId"
                [data]="lookups().flightTypes"
                textField="name"
                valueField="id"
                [valuePrimitive]="true"
                [kendoDropDownFilter]="{ operator: 'contains' }"
            ></kendo-combobox>
            @if (groundRun()) {
                <app-field-message kind="info">{{ "FLIGHT_LIST.edit.groundRun.typeLocked" | translate }}</app-field-message>
            } @else if (group().controls.flightTypeId.hasError("groundRunConversion")) {
                <app-field-message kind="warning">{{ "FLIGHT_LIST.edit.groundRun.notConvertible" | translate }}</app-field-message>
            }
        </label>
        <label class="field">
            <span class="label">VEMD</span>
            <kendo-textbox formControlName="vemd"></kendo-textbox>
        </label>
        <div class="fields triple">
            <label class="field">
                <span class="label">{{ "FLIGHT_LIST.landings" | translate }}</span>
                <kendo-numerictextbox formControlName="landings" format="#" [decimals]="0" [min]="0" [spinners]="false"></kendo-numerictextbox>
            </label>
            <label class="field">
                <span class="label">{{ "FLIGHT_LIST.cycles" | translate }}</span>
                <kendo-numerictextbox formControlName="cycles" format="#" [decimals]="0" [min]="0" [spinners]="false"></kendo-numerictextbox>
            </label>
        </div>

        <div class="fields pairs">
            <label class="field check">
                <input type="checkbox" kendoCheckBox formControlName="isHotRefuelFlight" />
                <span class="label">{{ "FLIGHT_LIST.edit.multiStop" | translate }}</span>
            </label>
            <label class="field check">
                <input type="checkbox" kendoCheckBox formControlName="isPositioning" />
                <span class="label">{{ "FLIGHT_LIST.isPositioning" | translate }}</span>
            </label>
        </div>

        <!-- The lists of the organization: a multiselect has no arrow of its own, so the field takes one to show it opens a list. -->
        <label class="field">
            <span class="label">{{ "FLIGHT_LIST.edit.lists.specifications" | translate }}</span>
            <span class="list-select">
                <kendo-multiselect
                    formControlName="flightSpecifications"
                    [data]="lookups().flightSpecifications"
                    textField="name"
                    valueField="id"
                    [valuePrimitive]="true"
                    [checkboxes]="true"
                    [autoClose]="false"
                    [placeholder]="'FLIGHT_LIST.edit.notChosen' | translate"
                    [kendoDropDownFilter]="{ operator: 'contains' }"
                ></kendo-multiselect>
                <kendo-svgicon class="list-arrow" [icon]="icons.arrow"></kendo-svgicon>
            </span>
        </label>
        <label class="field">
            <span class="label">{{ "FLIGHT_LIST.edit.lists.operations" | translate }}</span>
            <span class="list-select">
                <kendo-multiselect
                    formControlName="flightOperations"
                    [data]="lookups().flightOperations"
                    textField="name"
                    valueField="id"
                    [valuePrimitive]="true"
                    [checkboxes]="true"
                    [autoClose]="false"
                    [placeholder]="'FLIGHT_LIST.edit.notChosen' | translate"
                    [kendoDropDownFilter]="{ operator: 'contains' }"
                ></kendo-multiselect>
                <kendo-svgicon class="list-arrow" [icon]="icons.arrow"></kendo-svgicon>
            </span>
        </label>
        <label class="field">
            <span class="label">{{ "FLIGHT_LIST.edit.lists.typeNotes" | translate }}</span>
            <span class="list-select">
                <kendo-multiselect
                    formControlName="flightTypeNotes"
                    [data]="lookups().flightTypeNotes"
                    textField="name"
                    valueField="id"
                    [valuePrimitive]="true"
                    [checkboxes]="true"
                    [autoClose]="false"
                    [placeholder]="'FLIGHT_LIST.edit.notChosen' | translate"
                    [kendoDropDownFilter]="{ operator: 'contains' }"
                ></kendo-multiselect>
                <kendo-svgicon class="list-arrow" [icon]="icons.arrow"></kendo-svgicon>
            </span>
        </label>
    </div>
</fieldset>
